import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
   providedIn: 'root'
})
export class ClientDataService
{

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public getEmptyModel() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client/GetEmptyModel`;
      return this.httpClient.get(url);
   }

  public getListPage(start, count, sortBy, sortDirection, filters) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client/GetList?start=${start}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&filters=${JSON.stringify(filters)}`;
    return this.httpClient.get(url);
  }

  public getList() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client/SearchList?search=`;
    return this.httpClient.get(url);
  }

   public searchList(search) {
     let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client/SearchList?search=${encodeURIComponent(search)}`;
      return this.httpClient.get(url);
   }

  public searchByLocation(address1, city, state, zip) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client/SearchByLocation?address1=${encodeURIComponent(address1)}&city=${encodeURIComponent(city)}&state=${encodeURIComponent(state)}&zip=${encodeURIComponent(zip)}`;
    return this.httpClient.get(url);
  }

   public getById(id) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client/GetClient?id=${id}`;
      return this.httpClient.get(url);
   }

  public getClientByAddress(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client/GetClientByAddress`;
    return this.httpClient.post(url,dto);
  }

   public addClientProvider(clientProvider) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client/AddClientProvider`;
      return this.httpClient.post(url, clientProvider);
   }

   public save(client) {
      if (client.Id === 0) {
        let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client`;
         return this.httpClient.post(url, client);
      } else {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client?id=${client.Id}`;
         return this.httpClient.put(url, client);
      }
   }
}
